import { render, staticRenderFns } from "./SfBadge.vue?vue&type=template&id=d8f0a870&functional=true"
import script from "./SfBadge.vue?vue&type=script&lang=js"
export * from "./SfBadge.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfBadge.vue?vue&type=style&index=0&id=d8f0a870&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  injectStyles,
  null,
  "d2ffef2e"
  
)

export default component.exports